import ContentPanel from './content-panel';

export default ContentPanel;